const useFormatCurrency = (price, currency) => {
    const formatter = new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0
    });
    return {
        price: formatter.format(price)
    };
};
export default useFormatCurrency;
